"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountingMethodSchema = exports.accountingMethodIterable = void 0;
const zod_1 = require("zod");
exports.accountingMethodIterable = ['accrual', 'cash'];
exports.accountingMethodSchema = zod_1.z.enum(exports.accountingMethodIterable);
//# sourceMappingURL=RailzApiQueryParams.js.map